import { Toaster as Sonner, ToasterProps } from "sonner";

/**
 * Toaster renders the toasts of the app, styled with our popover tokens.
 *
 * The theme is pinned to light. The app never sets the `.dark` class, so
 * letting sonner follow the OS only desynchronised the two: sonner styles
 * a toast's description with a hard coded color on a child element
 * (`#e8e8e8` in its dark theme), which the variables set here do not
 * reach, leaving white text on our always white popover background.
 * Wiring up dark mode means applying `.dark` app wide; this prop follows
 * it then.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
